import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { AnyObject } from '@mri/types';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-install-prompt-dialog',
  standalone: true,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButtonModule
  ],
  templateUrl: './install-prompt-dialog.component.html',
  styleUrl: './install-prompt-dialog.component.scss'
})
export class InstallPromptDialogComponent {
  constructor(public dialogRef: MatDialogRef<InstallPromptDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: AnyObject) {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  install(): void {
    this.data.deferredPrompt.prompt();
    this.data.deferredPrompt.userChoice.then((choiceResult: AnyObject) => {
      if (choiceResult.outcome === 'accepted') {
        console.log('User accepted the A2HS prompt');
      } else {
        console.log('User dismissed the A2HS prompt');
      }
      this.dialogRef.close();
    });
  }
}
